"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MULTI_SELECT_MAX_HEIGHT = exports.DROPDOWN_BUTTON_MAX_HEIGHT = void 0;
var DROPDOWN_BUTTON_MAX_HEIGHT = '130px';
exports.DROPDOWN_BUTTON_MAX_HEIGHT = DROPDOWN_BUTTON_MAX_HEIGHT;
var MULTI_SELECT_MAX_HEIGHT = '150px';
exports.MULTI_SELECT_MAX_HEIGHT = MULTI_SELECT_MAX_HEIGHT;
//# sourceMappingURL=constants.js.map